import JsonLd from "@/components/feature/JsonLd";
import useSeo from "@/hooks/useSeo";
import CategorySection from "@/pages/home/components/CategorySection";
import FaqSection from "@/pages/home/components/FaqSection";
import HeroSection from "@/pages/home/components/HeroSection";
import HotRanking from "@/pages/home/components/HotRanking";
import LiveTimeline from "@/pages/home/components/LiveTimeline";
import StatsBand from "@/pages/home/components/StatsBand";
import SubscribeCta from "@/pages/home/components/SubscribeCta";
import TopicGrid from "@/pages/home/components/TopicGrid";
import PrinciplesSection from "@/components/feature/PrinciplesSection";
import VoiceSection from "@/components/feature/VoiceSection";
import { faqs, siteInfo } from "@/mocks/site";

const siteUrl = "https://baoliaoqianxian.example.com/";

export default function Home() {
  useSeo({
    title: "独家爆料 - 最新第一手进展持续追踪，反转后续不间断更新",
    description:
      "独家爆料持续更新最新、第一手进展，追踪热点事件的反转与后续，梳理完整时间线，关键信息首发直达，第一时间掌握未被删减的原始内幕与动态。",
    keywords: "独家爆料,独家爆料最新,独家爆料第一手,独家爆料追踪,独家爆料反转,独家爆料后续",
    canonicalPath: "/",
    ogType: "website",
  });

  return (
    <>
      <JsonLd
        id="home-website"
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: siteInfo.name,
          description: siteInfo.description,
          url: siteUrl,
          inLanguage: "zh-CN",
          potentialAction: {
            "@type": "SearchAction",
            target: `${siteUrl}events?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <JsonLd
        id="home-org"
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: siteInfo.name,
          description: siteInfo.description,
          url: siteUrl,
          email: siteInfo.contactEmail,
        }}
      />
      <JsonLd
        id="home-faq"
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: { "@type": "Answer", text: item.answer },
          })),
        }}
      />

      <HeroSection />
      <StatsBand />
      <LiveTimeline />
      <TopicGrid />
      <CategorySection />
      <HotRanking />
      <PrinciplesSection />
      <FaqSection />
      <VoiceSection />
      <SubscribeCta />
    </>
  );
}